import { __assign } from "tslib";
import * as React from 'react';
import WarningComponent from '@websky/core/src/Warnings/Warnings';
import cn from 'classnames';
import css from './Warnings.css';
var Warnings = function (props) {
    var _a;
    var subsidy = props.warnings.some(function (warning) { return warning.includes('subsid'); });
    return (React.createElement(WarningComponent, __assign({}, props, { needToTranslate: true, className: cn((_a = {},
            _a[css.subsidyError] = subsidy,
            _a)) })));
};
export default Warnings;
